import React, { useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTicketAlt, faUserShield, faSignInAlt, faRocket, faChartLine, faClock } from '@fortawesome/free-solid-svg-icons';
import './Home.css';

// Get the main Nodesail URL from environment variable or use a default
const MAIN_NODESAIL_URL = process.env.REACT_APP_MAIN_NODESAIL_URL || 'http://localhost:3000';

const Home: React.FC = () => {
  const { isAuthenticated, isAdmin } = useContext(AuthContext);
  
  useEffect(() => {
    document.title = 'Nodesail Support';
  }, []);
  
  // Handle SSO login with main Nodesail app
  const handleSSOLogin = (e: React.MouseEvent) => {
    e.preventDefault();
    
    // Get the current origin for the callback URL
    const callbackUrl = `${window.location.origin}/auth/callback`;
    
    // Redirect to the main Nodesail OAuth endpoint
    window.location.href = `${MAIN_NODESAIL_URL}/api/auth/support/authorize?redirect_uri=${encodeURIComponent(callbackUrl)}`;
  };
  
  return (
    <div className="container">
      <div className="row justify-content-center text-center">
        <div className="col-md-10">
          <div className="my-5">
            <h1 className="display-4 fw-bold mb-2">Nodesail Support</h1>
            <p className="lead mb-4 welcome-text">
              Our expert support team is available to assist you with any technical issues.
            </p>
            
            {!isAuthenticated ? (
              <div className="d-grid gap-3 d-sm-flex justify-content-sm-center mb-5">
                <Link to="/login" className="btn btn-primary btn-lg px-4 gap-3 shadow-sm" onClick={handleSSOLogin}>
                  <FontAwesomeIcon icon={faSignInAlt} className="me-2" />
                  Continue with Nodesail
                </Link>
              </div>
            ) : (
              <div className="d-grid gap-3 d-sm-flex justify-content-sm-center mb-5">
                {isAdmin ? (
                  <Link to="/admin" className="btn btn-primary btn-lg px-4 gap-3 shadow-sm">
                    <FontAwesomeIcon icon={faUserShield} className="me-2" />
                    Admin Dashboard
                  </Link>
                ) : (
                  <Link to="/tickets/new" className="btn btn-primary btn-lg px-4 gap-3 shadow-sm">
                    <FontAwesomeIcon icon={faTicketAlt} className="me-2" />
                    Create a Ticket
                  </Link>
                )}
              </div>
            )}
          </div>
          
          <hr className="my-5" />
          
          <div className="row g-4 py-5">
            <div className="col-md-4">
              <div className="card h-100 shadow">
                <div className="card-body text-center p-4">
                  <FontAwesomeIcon icon={faRocket} size="2x" className="text-primary mb-3" />
                  <h3 className="card-title h4">Quick Support</h3>
                  <p className="card-text">Get fast responses from our support team for all your issues.</p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card h-100 shadow">
                <div className="card-body text-center p-4">
                  <FontAwesomeIcon icon={faChartLine} size="2x" className="text-primary mb-3" />
                  <h3 className="card-title h4">Track Progress</h3>
                  <p className="card-text">Easily track the status and updates of your support tickets.</p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card h-100 shadow">
                <div className="card-body text-center p-4">
                  <FontAwesomeIcon icon={faClock} size="2x" className="text-primary mb-3" />
                  <h3 className="card-title h4">Always Available</h3>
                  <p className="card-text">Our support platform is accessible 24/7 for your convenience.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;